import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import Moment from "react-moment";
//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
//Components
import Layout from "../../../../../Layout/Layout";
import Constants from "../../../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

import ShowStatus from "../../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
// import configFromEnv from "../../../../../services/configuration";
import {
  formatDate,
} from "../../../../../common/Validations";
import { SearchField } from "../../../../../Components/formElements/SearchField";
import CancelModal from "../../../../../Components/Modal/supplier_app/common/CancelModal";
import InventoryConstants from "../../../../../common/InventoryConstants";
import { addWarehouse, getWarehouseList } from "../../../../../redux/feature/inventory_app/inventorySlice";
// import CommonItemLevelDatatableModal from "../../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";

const WareHouseList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Warehouse");
  localStorage.setItem("submenu", "Warehouse");

  let warehouseData = useSelector((state) => state?.inventory?.warehouse); // User Details from Store
  let warehouseDatatable = useSelector(
    (state) => state?.inventory?.warehouse?.pagination
  ); // User Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");

  // const [getItemLevelData, setItemLevelData] = useState([]);
  // const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  // const [getModalTitle, setModalTitle] = useState("");
  // const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  // const warehoueData = [

  //   {
  //     warehouseNr: "WH001",
  //     warehouseName: "South Bangalore Main WH",
  //     addressLine1: "#27, Hosur Road, Near Electronic City, Phase 1",
  //     city: "Bengaluru",
  //     state: "IN - Karnataka",
  //     country: "IN - India",
  //     postalCode: "560100",
  //     companyCode: "AST-IND-BLR-001",
  //     contactPerson: {
  //       jobTitle: "Warehouse Supervisor",
  //       contactTitle: "Mr.",
  //       contactPerson: "Arjun Reddy",
  //       contactNumber: "+91-9876543210",
  //       email: "arjun.reddy@astraltech.in"
  //     },
  //     document: {
  //       documentType: "Government License",
  //       documentNumber: "LIC-KA-WH-2025-001",
  //       issueDate: "2025-04-15",
  //       attachment: "license_doc.pdf"
  //     }
  //   },
  //   {
  //     warehouseNr: "WH002",
  //     warehouseName: "Mumbai Logistics Hub",
  //     addressLine1: "Plot 12, MIDC Industrial Area, Andheri East",
  //     city: "Mumbai",
  //     state: "IN - Maharashtra",
  //     country: "IN - India",
  //     postalCode: "400093",
  //     companyCode: "AST-IND-MUM-002",
  //     contactPerson: {
  //       jobTitle: "Logistics Manager",
  //       contactTitle: "Ms.",
  //       contactPerson: "Priya Deshmukh",
  //       contactNumber: "+91-9988776655",
  //       email: "priya.deshmukh@astraltech.in"
  //     },
  //     document: {
  //       documentType: "Trade Certificate",
  //       documentNumber: "TRD-MH-WH-2025-002",
  //       issueDate: "2025-03-10",
  //       attachment: "trade_cert_mumbai.pdf"
  //     }
  //   },
  //   {
  //     warehouseNr: "WH003",
  //     warehouseName: "Chennai Regional Storage",
  //     addressLine1: "No. 78, Industrial Corridor, SIPCOT, Irungattukottai",
  //     city: "Chennai",
  //     state: "IN - Tamil Nadu",
  //     country: "IN - India",
  //     postalCode: "602117",
  //     companyCode: "AST-IND-CHE-003",
  //     contactPerson: {
  //       jobTitle: "Inventory Head",
  //       contactTitle: "Mr.",
  //       contactPerson: "Ravi Kumar",
  //       contactNumber: "+91-9876123456",
  //       email: "ravi.kumar@astraltech.in"
  //     },
  //     document: {
  //       documentType: "Storage License",
  //       documentNumber: "STO-TN-WH-2025-003",
  //       issueDate: "2025-01-20",
  //       attachment: "storage_license_chennai.pdf"
  //     }
  //   },
  //   {
  //     warehouseNr: "WH004",
  //     warehouseName: "Delhi NCR Distribution Center",
  //     addressLine1: "Sector 59, Noida-Greater Noida Expressway",
  //     city: "Noida",
  //     state: "IN - Uttar Pradesh",
  //     country: "IN - India",
  //     postalCode: "201301",
  //     companyCode: "AST-IND-DEL-004",
  //     contactPerson: {
  //       jobTitle: "Operations Coordinator",
  //       contactTitle: "Mr.",
  //       contactPerson: "Amit Sharma",
  //       contactNumber: "+91-9811122233",
  //       email: "amit.sharma@astraltech.in"
  //     },
  //     document: {
  //       documentType: "Compliance Certificate",
  //       documentNumber: "CMP-UP-WH-2025-004",
  //       issueDate: "2025-05-01",
  //       attachment: "compliance_delhi.pdf"
  //     }
  //   },
  //   {
  //     warehouseNr: "WH005",
  //     warehouseName: "Hyderabad Storage Yard",
  //     addressLine1: "Survey No. 45, Gachibowli Industrial Area",
  //     city: "Hyderabad",
  //     state: "IN - Telangana",
  //     country: "IN - India",
  //     postalCode: "500032",
  //     companyCode: "AST-IND-HYD-005",
  //     contactPerson: {
  //       jobTitle: "Warehouse Lead",
  //       contactTitle: "Ms.",
  //       contactPerson: "Sneha Iyer",
  //       contactNumber: "+91-9900123456",
  //       email: "sneha.iyer@astraltech.in"
  //     },
  //     document: {
  //       documentType: "Fire Safety Certificate",
  //       documentNumber: "FSC-TG-WH-2025-005",
  //       issueDate: "2025-06-05",
  //       attachment: "fire_safety_hyd.pdf"
  //     }
  //   }
  // ]

  // const itemLevelHideModal = () => {
  //   setItemLevelModalShow(false);
  // };

  /* Modal Function */
  const createWarehouse = () => {
    // setModalShow(true);
    navigate(InventoryConstants.INVENTORY_WAREHOUSE_CREATION);
  };
  const detailedPage = (warehouseNr) => {
    dispatch(addWarehouse(warehouseNr));
    navigate(InventoryConstants.INVENTORY_WAREHOUSE_DETAILS);
  };
  //on page load
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    {
      name: "Warehouse Nr",
      selector: (row) => row?.warehouseNr,
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => detailedPage(row?.warehouseNr)}
          >
            {row?.warehouseNr || "-"}{" "}
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Warehouse Name",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.warehouseName}</span>
        </>
      ),
      selector: (row) => row.driverName,
      sortable: true,
      width: "180px",
    },

    {
      name: "Address",
      selector: (row) => row.address || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.address} </p>
          <p className="m-0 p-0 fw-bold">{row.address2} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "City",
      selector: (row) => row.city || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.city} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.address2} </p> */}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Postal Code",
      selector: (row) => row.cityPostalCode || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.cityPostalCode} </p>
          {/* <p className="m-0 p-0 fw-bold">{row.address2} </p> */}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactDetails?.[0]?.contactName || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.contactDetails?.[0]?.contactName || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.contactDetails?.[0]?.contactNumber || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.contactDetails?.[0]?.contactNumber || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.contactDetails?.[0]?.contactEmail || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.contactDetails?.[0]?.contactEmail || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      width: "160px",
    },
  ];
  const loadInitialPoData = async () => {
    setData(warehouseData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "GET_WAREHOUSE_LIST",
      module: "WAREHOUSE",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getWarehouseList(obj));
    setData(warehouseData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_WAREHOUSE_LIST",
      module: "WAREHOUSE",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getWarehouseList(obj));
    setData(warehouseData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_WAREHOUSE_LIST",
      module: "WAREHOUSE",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getWarehouseList(obj));
  };

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "GET_WAREHOUSE_LIST",
      module: "WAREHOUSE",
      page: 1,
      per_page: 10,
    };
    dispatch(getWarehouseList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialPoData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouseData]);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled"
    );
    setSelectedRows(validRows);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Warehouse</h2>
                <p className="subText">Lists of Warehouse and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">WL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Warehouse List</span>
                      <span className="subHeaderTitle">
                        View of Warehouse{" "}
                      </span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => createWarehouse()}
                        >
                          <i className="bi bi-clipboard-check"></i> Add Warehouse
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={warehouseData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={warehouseDatatable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      {/* <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      /> */}
    </main>
  );
};

export default WareHouseList;
